export default [{
  name: 'recebiveis',
  namespaced: true,
  state: {
    model: {
      Pessoa: {
        PessoaBanco: {},
        PessoaEndereco: {},
        PessoaDadosContato: {},
        DocumentoFederal: ''
      },
      Parcela: {},
      CountGarantia: 0,
      CountAvalista: 0,
      Credenciadora: []
    },
    dadosIniciais: {
      pessoaParceiroLimiteCredito: {}
    },
    pessoa: {
      PessoaBanco: {},
      PessoaEndereco: {},
      PessoaDadosContato: {},
      DocumentoFederal: ''
    }
  },
  mutations: {
    model (state, obj) {
      state.model = obj
    },
    dadosIniciais (state, obj) {
      state.dadosIniciais = obj
    }
  },
  getters: {
    model (state) {
      return state.model
    },
    dadosIniciais (state) {
      return state.dadosIniciais
    },
  },
  actions: {
    clearModel ({ commit }) {
      const data = {
        Pessoa: {
          PessoaBanco: {},
          PessoaEndereco: {},
          PessoaDadosContato: {},
          DocumentoFederal: ''
        },
        Credenciadora: [],
        Parcela: {},
        Proposta: {},
        CountAvalista: 0,
        CountGarantia: 0,
      }
      commit('model', data)
      commit('dadosIniciais', { pessoaParceiroLimiteCredito: {} })
    },
  },
  beforeEach ({ getters, commit }, { to, from, next }) {
    switch (to.fullPath) {
      case '/':
        if (localStorage.ambiente) { next({ path: '/partner/' + localStorage.ambiente }) }
        break;
    }
  },
  logoutFunctions: {
    // beforeClear(state) {
    //  console.log('a')
    // },
    afterClear (state) {
      location.href = '/partner/' + state.empresa.ambiente
    },
  }
}]
